module.exports = __webpack_public_path__ + "static/media/no_route_bg.30ec0922.jpg";